module.exports = __webpack_public_path__ + "static/media/arrow-to-left.55e4dd4d.svg";